const MuiAccordionDetails = {
  styleOverrides: {
    root: {
      padding: '0px !important',
    },
  },
};

export default MuiAccordionDetails;
